import {
  Box,
  SimpleGrid,
  Button,
  useDisclosure,
  useToast,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  HStack,
  Badge,
  VStack,
  Flex,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Switch,
  Icon,
  InputGroup,
  InputLeftElement,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Card,
  Checkbox,
  useColorModeValue,
  Divider,
} from "@chakra-ui/react";
import {
  MdLocationOn,
  MdVisibility,
  MdEdit,
  MdDelete,
  MdHomeRepairService,
  MdBuild,
  MdSearch,
  MdAdd,
  MdMoreVert,
  MdGridView,
  MdList,
  MdChevronLeft,
  MdChevronRight,
  MdDirectionsCar,
  MdCheckCircle,
  MdWarning,
  MdError,
  MdArrowDownward,
} from "react-icons/md";
import config from "config/api";
import VehicleStatCard from "components/card/VehicleStatCard";
import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import {
  getVehicules, getVehicule, updateVehicule, deleteVehicule, getUsers, getUsersid, getUser, getMateriels, getUtilisationMateriel, getPatient, getMission, createVehicule, createDispatch, updateVehiculesBatch, checkToken, getMaintenanceTasks, createMaintenanceTask, updateMaintenanceTask, deleteMaintenanceTask, createMaintenanceTaskHistory, getMaintenanceTaskHistory, getVehicleMaintenanceHistory
} from "../../../api/api";
import { useNavigate } from "react-router-dom";
import { useNavbarAction } from "contexts/NavbarActionContext";
import LoadingSpinner from "components/LoadingSpinner";
import { usePermissions } from "hooks/usePermissions";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

const StatusBadge = ({ status }) => {
  const statusConfig = {
    actif: {
      bg: "#EDF7F1",
      border: "#CDE8D9",
      text: "#006133",
      label: "Actif"
    },
    active: {
      bg: "#EDF7F1",
      border: "#CDE8D9",
      text: "#006133",
      label: "Actif"
    },
    disponible: {
      bg: "#EDF7F1",
      border: "#CDE8D9",
      text: "#006133",
      label: "Disponible"
    },
    'en service': {
      bg: "#EDF7F1",
      border: "#CDE8D9",
      text: "#006133",
      label: "En service"
    },
    inactif: {
      bg: "#FDF2F2",
      border: "#FBD5D5",
      text: "#9B1C1C",
      label: "Inactif"
    },
    'en mission': {
      bg: "#EBF8FF",
      border: "#BEE3F8",
      text: "#2B6CB0",
      label: "En mission"
    },
    'en_mission': {
      bg: "#EBF8FF",
      border: "#BEE3F8",
      text: "#2B6CB0",
      label: "En mission"
    },
    'en pause': {
      bg: "#FFF5F5",
      border: "#FEB2B2",
      text: "#C53030",
      label: "En pause"
    },
    'pause': {
      bg: "#FFF5F5",
      border: "#FEB2B2",
      text: "#C53030",
      label: "En pause"
    },
    maintenance: {
      bg: "#FFFAF0",
      border: "#FEEBC8",
      text: "#C05621",
      label: "Maintenance"
    },
    'en maintenance': {
      bg: "#FFFAF0",
      border: "#FEEBC8",
      text: "#C05621",
      label: "En maintenance"
    },
    'en_maintenance': {
      bg: "#FFFAF0",
      border: "#FEEBC8",
      text: "#C05621",
      label: "En maintenance"
    }
  };

  const normalizedStatus = status?.toLowerCase() || 'actif';
  const config = statusConfig[normalizedStatus] || {
    bg: "#F7FAFC",
    border: "#E2E8F0",
    text: "#4A5568",
    label: status
  };

  return (
    <HStack
      spacing={2}
      bg={config.bg}
      border="1px solid"
      borderColor={config.border}
      px={3}
      py={1}
      borderRadius="full"
      w="fit-content"
      align="center"
    >
      <Box w="8px" h="8px" borderRadius="full" bg={config.text} />
      <Text fontSize="13px" fontWeight="600" color={config.text}>
        {config.label}
      </Text>
    </HStack>
  );
};

/** Libellés inventaire : consommable, dispositif, pharmacie (+ autre si type inconnu) */
const MATERIEL_CATEGORY_LABELS = {
  consommable: "Consommable",
  dispositif: "Dispositif",
  pharmacie: "Pharmacie",

};

const normalizeTypeString = (s) =>
  (s == null ? "" : String(s))
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const getMaterielCategoryKey = (type) => {
  const t = normalizeTypeString(type);
  if (!t) return "autre";
  if (t.includes("pharmacie")) return "pharmacie";
  if (t.includes("consommable")) return "consommable";
  if (t.includes("dispositif")) return "dispositif";
  return "autre";
};

const groupMaterialsByCategory = (materials) => {
  const groups = { consommable: [], dispositif: [], pharmacie: [], autre: [] };
  (materials || []).forEach((m) => {
    groups[getMaterielCategoryKey(m?.type)].push(m);
  });
  return groups;
};

const getUsageItemCategory = (usageRow, vehicleMaterials) => {
  if (usageRow?.type != null && String(usageRow.type).trim() !== "") {
    return getMaterielCategoryKey(usageRow.type);
  }
  const found = (vehicleMaterials || []).find(
    (m) => m.item === usageRow.item
  );
  return found ? getMaterielCategoryKey(found.type) : "autre";
};

const groupUsageItemsByCategory = (items, vehicleMaterials) => {
  const groups = { consommable: [], dispositif: [], pharmacie: [], autre: [] };
  (items || []).forEach((u) => {
    groups[getUsageItemCategory(u, vehicleMaterials)].push(u);
  });
  return groups;
};

export default function Settings() {
  const navigate = useNavigate();
  const { navbarHeight, setOnCreateVehicule, showStats, setShowStats } = useNavbarAction();
  const { hasPermission } = usePermissions();
  const [tableData, setTableData] = useState([]);
  const [ambulanciers, setAmbulanciers] = useState([]);
  const [infirmiers, setinfirmiers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [viewMode, setViewMode] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const cancelRef = useRef();
  const tableDataRef = useRef([]);
  const toast = useToast();
  const [locationData, setLocationData] = useState({ lat: null, lon: null });
  const [reassignConfirm, setReassignConfirm] = useState(false);
  const [reassignData, setReassignData] = useState(null);
  const [inventoryData, setInventoryData] = useState(null);
  const [usageHistory, setUsageHistory] = useState([]);
  const {
    isOpen: isInventoryOpen,
    onOpen: onInventoryOpen,
    onClose: onInventoryClose,
  } = useDisclosure();

  // Maintenance states
  const [maintenanceData, setMaintenanceData] = useState(null);
  const [maintenanceTasks, setMaintenanceTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [taskHistory, setTaskHistory] = useState([]);
  const [vehicleHistory, setVehicleHistory] = useState([]);
  const {
    isOpen: isMaintenanceOpen,
    onOpen: onMaintenanceOpen,
    onClose: onMaintenanceClose,
  } = useDisclosure();
  const {
    isOpen: isTaskModalOpen,
    onOpen: onTaskModalOpen,
    onClose: onTaskModalClose,
  } = useDisclosure();
  const {
    isOpen: isHistoryModalOpen,
    onOpen: onHistoryModalOpen,
    onClose: onHistoryModalClose,
  } = useDisclosure();
  const {
    isOpen: isVehicleHistoryOpen,
    onOpen: onVehicleHistoryOpen,
    onClose: onVehicleHistoryClose,
  } = useDisclosure();
  // loc Modal (déclaré avant les useEffect qui l'utilisent)
  const {
    isOpen: islocOpen,
    onOpen: onlocOpen,
    onClose: onlocClose,
  } = useDisclosure();

  const [dispatchData, setDispatchData] = useState({
    description: "",
    loc: "",
    ambulance_id: null
  });

  const [selectedLocation, setSelectedLocation] = useState(null);

  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const mapRef = useRef(null);

  useEffect(() => {
    // Charger l'API Google Maps
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!islocOpen || !locationData.lat || !locationData.lon || !mapRef.current || !window.google) {
      return;
    }

    if (!map) {
      const initialLocation = { lat: locationData.lat, lng: locationData.lon };

      const newMap = new window.google.maps.Map(mapRef.current, {
        center: initialLocation,
        zoom: 15,
        styles: [
          { "elementType": "geometry", "stylers": [{ "color": "#ebe3cd" }] },
          { "elementType": "labels.text.fill", "stylers": [{ "color": "#523735" }] },
          { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f1e6" }] },
          { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#c9b2a6" }] },
          { "featureType": "administrative.land_parcel", "elementType": "geometry.stroke", "stylers": [{ "color": "#dcd2be" }] },
          { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#ae9e90" }] },
          { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#93817c" }] },
          { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#006133" }] },
          { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#447530" }] },
          { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#f5f1e6" }] },
          { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#fdfcf8" }] },
          { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#f8c967" }] },
          { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#e9bc62" }] },
          { "featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{ "color": "#e98d58" }] },
          { "featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{ "color": "#db8555" }] },
          { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#806b63" }] },
          { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{ "color": "#8f7d77" }] },
          { "featureType": "transit.line", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ebe3cd" }] },
          { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#b9d3c2" }] },
          { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#92998d" }] }
        ],
      });

      const newMarker = new window.google.maps.Marker({
        position: initialLocation,
        map: newMap,
        draggable: true,
      });

      newMarker.addListener("dragend", (e) => {
        const position = e.latLng;
        setSelectedLocation({ lat: position.lat(), lng: position.lng() });
        setLocationData({ lat: position.lat(), lon: position.lng() });
      });

      setMap(newMap);
      setMarker(newMarker);
      return;
    }

    // Si la carte existe déjà, on recentre simplement sur la nouvelle ambulance
    const nextLocation = { lat: locationData.lat, lng: locationData.lon };
    map.setCenter(nextLocation);
    map.setZoom(15);
    if (marker) {
      marker.setPosition(nextLocation);
    }
  }, [islocOpen, locationData.lat, locationData.lon, map, marker]);

  // Calcul des statistiques
  const stats = React.useMemo(() => {
    const total = tableData.length;
    const enService = tableData.filter(v => {
      const statut = (v.statut || '').toLowerCase().replace(/_/g, ' ');
      return statut === 'en service' || statut === 'disponible' || statut === 'actif';
    }).length;
    const enMission = tableData.filter(v => {
      const statut = (v.statut || '').toLowerCase().replace(/_/g, ' ');
      return statut === 'en mission';
    }).length;
    const enMaintenance = tableData.filter(v => {
      const statut = (v.statut || '').toLowerCase().replace(/_/g, ' ');
      return statut === 'maintenance' || statut === 'en maintenance';
    }).length;

    return {
      total,
      enService,
      enMission,
      enMaintenance,
    };
  }, [tableData]);

  // Fonction pour formater le type de véhicule
  const formatVehicleType = (type) => {
    if (!type) return '---';
    const typeLower = type.toLowerCase().trim();
    if (typeLower === 'tas') return 'TAS';
    if (typeLower === 'tar') return 'TAR';
    return type; // Retourne le type tel quel si ce n'est pas TAS/TAR
  };

  // Compteurs par type
  const typeCounts = React.useMemo(() => {
    return {
      all: tableData.length,
      TAS: tableData.filter(v => {
        const type = (v.type_vehicule || '').toLowerCase().trim();
        return type === 'tas';
      }).length,
      TAR: tableData.filter(v => {
        const type = (v.type_vehicule || '').toLowerCase().trim();
        return type === 'tar';
      }).length,
    };
  }, [tableData]);

  const filteredData = React.useMemo(() => {
    let filtered = tableData;

    // Filtre par recherche
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(vehicle => {
        return (
          (vehicle.immatriculation?.toLowerCase() || '').includes(searchLower) ||
          (vehicle.ambulancierName?.toLowerCase() || '').includes(searchLower) ||
          (vehicle.infirmierName?.toLowerCase() || '').includes(searchLower) ||
          (vehicle.type_vehicule?.toLowerCase() || '').includes(searchLower) ||
          (vehicle.statut?.toLowerCase() || '').includes(searchLower) ||
          (vehicle.tracker_id?.toString() || '').includes(searchLower) ||
          (vehicle.km?.toString() || '').includes(searchLower)
        );
      });
    }

    // Filtre par type
    if (typeFilter !== "all") {
      filtered = filtered.filter(vehicle => {
        const type = (vehicle.type_vehicule || '').toUpperCase().trim();
        return type === typeFilter;
      });
    }

    // Filtre par statut
    if (statusFilter !== "all") {
      filtered = filtered.filter(vehicle => {
        const statut = (vehicle.statut || '').toLowerCase().replace(/_/g, ' ');
        if (statusFilter === "en service") {
          return statut === 'en service' || statut === 'disponible' || statut === 'actif' || statut === 'active';
        }
        if (statusFilter === "en maintenance") {
          return statut === 'maintenance' || statut === 'en maintenance';
        }
        return statut === statusFilter.toLowerCase();
      });
    }

    return filtered;
  }, [tableData, searchTerm, typeFilter, statusFilter]);

  // Pagination
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const closeLocModal = () => {
    setLocationData({ lat: null, lon: null });
    setSelectedLocation(null);
    if (marker) {
      marker.setMap(null);
    }
    setMarker(null);
    setMap(null);
    onlocClose();
  };

  const addOneDayForDateInput = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";
      date.setDate(date.getDate() + 1);
      return date.toISOString().split("T")[0];
    } catch (error) {
      console.error("Error processing date:", error);
      return "";
    }
  };

  // Edit Modal
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const [editData, setEditData] = useState(null);
  const [viewData, setviewData] = useState(null);
  const [locData, setlocData] = useState(null);
  const [initialData, setInitialData] = useState(null);
  const [unsaved, setUnsaved] = useState(false);
  // Add Modal
  const {
    isOpen: isAddOpen,
    onOpen: onAddOpen,
    onClose: onAddClose,
  } = useDisclosure();
  // view Modal
  const {
    isOpen: isviewOpen,
    onOpen: onviewOpen,
    onClose: onviewClose,
  } = useDisclosure();
  const [newVehiculeData, setNewVehiculeData] = useState({
    immatriculation: "",
    type_vehicule: "tas",
    statut: "disponible",
    tracker_id: 0,
    dernier_entretien: null,
    next_entretien: null,
    user_id: null,
    infirmier: null,
    ville: "Casablanca",
  });

  // Maintenance form states
  const [newTaskData, setNewTaskData] = useState({
    name: "",
    status: "ok",
    next_due_date: "",
    last_performed_at: "",
    notes: "",
    user_id: null
  });

  const [taskHistoryData, setTaskHistoryData] = useState({
    action: "",
    from_status: "",
    to_status: "",
    next_due_date_set: "",
    odometer_km: "",
    cost_mad: "",
    notes: "",
    user_id: null
  });

  const [statusChangeData, setStatusChangeData] = useState({
    taskId: null,
    fromStatus: "",
    toStatus: "",
    action: "",
    odometer_km: "",
    cost_mad: "",
    notes: "",
    next_due_date_set: ""
  });

  const {
    isOpen: isAlertOpen,
    onOpen: onAlertOpen,
    onClose: onAlertClose,
  } = useDisclosure();

  // Configurer le contexte NavbarActionContext pour la navbar
  useEffect(() => {
    setOnCreateVehicule(() => onAddOpen);
    return () => {
      setOnCreateVehicule(null);
    };
  }, [onAddOpen, setOnCreateVehicule]);

  useEffect(() => {
    const checkTokenAndUser = async () => {
      try {
        // 1. Vérifier la validité de la session
        const check = await checkToken(); // le backend lit le cookie
        if (!check.data.valid) {
          navigate('/auth/sign-in');
          return;
        }

        // 2. Récupérer les infos utilisateur
        const user = await getUser(); // le backend lit le cookie
        const userRole = user.rôle || user['rÃ´le'] || user.role;
        if (
          userRole !== 'admin' &&
          userRole !== 'régulateur' &&
          userRole !== 'rÃ©gulateur' &&
          userRole !== 'médecin regulateur' &&
          userRole !== 'medecin regulateur'
        ) {
          navigate('/auth/sign-in');
          return;
        }

        // Si tout est ok, on charge les données
        fetchData();
      } catch (error) {
        console.error("Error:", error);
        navigate('/auth/sign-in');
      }
    };
    checkTokenAndUser();
  }, [navigate]);

  // Synchroniser la ref avec tableData
  useEffect(() => {
    tableDataRef.current = tableData;
  }, [tableData]);

  // Fonction pour récupérer le kilométrage depuis Navixy
  const fetchKmFromNavixy = async (trackerId) => {
    if (!trackerId) return null;

    try {
      const data = {
        // Utiliser le hash depuis la config (variable d'environnement)
        hash: config.navixy.hash,
        tracker_id: trackerId,
      };
      const response = await axios.post(
        `${config.navixy.apiUrl}/tracker/get_diagnostics`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          // Ne pas envoyer de cookies/credentials vers Navixy pour éviter les erreurs CORS
          withCredentials: false,
        }
      );
      const inputs = response.data.inputs;
      const km = inputs.find(input => input.type === "custom")?.value;
      return km || null;
    } catch (error) {
      console.error(`Error fetching km from Navixy for tracker ${trackerId}:`, error);
      return null;
    }
  };

  // Fonction pour mettre à jour uniquement le kilométrage
  const updateKilometrage = useCallback(async () => {
    try {
      // Utiliser la ref pour accéder aux données actuelles
      const currentData = tableDataRef.current;

      // Mettre à jour le kilométrage pour tous les véhicules
      const updatedData = await Promise.all(
        currentData.map(async (vehicule) => {
          let kmFromNavixy = null;
          if (vehicule.tracker_id) {
            kmFromNavixy = await fetchKmFromNavixy(vehicule.tracker_id);
          }

          return {
            ...vehicule,
            km: kmFromNavixy !== null ? kmFromNavixy : vehicule.km,
          };
        })
      );

      setTableData(updatedData);
      tableDataRef.current = updatedData; // Mettre à jour la ref
    } catch (err) {
      console.error("Error updating kilometrage:", err);
      // Ne pas afficher de toast pour les erreurs silencieuses d'actualisation
    }
  }, []);

  // Actualiser le kilométrage toutes les 5 secondes
  useEffect(() => {
    // Ne pas démarrer l'actualisation si les données ne sont pas encore chargées
    if (loading || tableData.length === 0) {
      return;
    }

    // Créer un intervalle pour actualiser le kilométrage toutes les 5 secondes
    const interval = setInterval(() => {
      updateKilometrage();
    }, 5000); // 5000 millisecondes = 5 secondes

    // Nettoyer l'intervalle quand le composant est démonté ou quand les dépendances changent
    return () => clearInterval(interval);
  }, [loading, tableData.length, updateKilometrage]); // Dépendances: loading, tableData.length et updateKilometrage

  const fetchData = async () => {
    try {
      // Fetch data in parallel
      const [vehiculesRes, usersRes] = await Promise.all([
        getVehicules(),
        getUsers()
      ]);



      // Validate data structure
      if (!Array.isArray(vehiculesRes.data)) {
        console.error('Vehicles data is not an array:', vehiculesRes.data);
        throw new Error('Invalid vehicles data format');
      }

      if (!Array.isArray(usersRes.data)) {
        console.error('Users data is not an array:', usersRes.data);
        throw new Error('Invalid users data format');
      }

      const ambulanciersData = usersRes.data.filter(user => user.rôle === "ambulancier");
      const infirmiersData = usersRes.data.filter(user => user.rôle === "infirmier");



      setAmbulanciers(ambulanciersData);
      setinfirmiers(infirmiersData);

      // Process data in parallel avec récupération du kilométrage depuis Navixy
      const updatedData = await Promise.all(vehiculesRes.data.map(async (vehicule) => {
        let formattedDate = "";
        try {
          if (vehicule.dernier_entretien) {
            const date = new Date(vehicule.dernier_entretien);
            if (!isNaN(date.getTime())) {
              formattedDate = date.toISOString().split('T')[0];
            }
          }
        } catch (error) {
          console.error("Error formatting date:", error);
        }

        const ambulancier = ambulanciersData.find(u => u.id === vehicule.user_id);
        const infirmier = infirmiersData.find(u => u.id === vehicule.infirmier);

        // Récupérer le kilométrage depuis Navixy si tracker_id existe
        let kmFromNavixy = null;
        if (vehicule.tracker_id) {
          kmFromNavixy = await fetchKmFromNavixy(vehicule.tracker_id);
        }

        return {
          ...vehicule,
          formattedDate,
          ambulancierName: ambulancier ? `${ambulancier.nom} ${ambulancier.prenom || ''}`.trim() : 'Pas ambulancier',
          infirmierName: infirmier ? `${infirmier.nom} ${infirmier.prenom || ''}`.trim() : 'Pas infirmier',
          km: kmFromNavixy || vehicule.km || null, // Utiliser le km de Navixy en priorité, sinon celui de la BD
        };
      }));


      setTableData(updatedData);
      tableDataRef.current = updatedData; // Mettre à jour la ref
    } catch (err) {
      console.error("Fetch error details:", {
        error: err,
        message: err.message,
        response: err.response?.data,
        status: err.response?.status
      });
      toast({
        title: "Error fetching data",
        description: err.message || "Failed to load vehicle data",
        status: "error",
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };


  const handleEdit = async (id) => {
    try {
      const res = await getVehicule(id);

      // Normaliser le type de véhicule
      const normalizedType = res.data.type_vehicule?.toLowerCase()?.trim();

      setInitialData({ ...res.data, type_vehicule: normalizedType });
      setEditData({ ...res.data, type_vehicule: normalizedType });
      setUnsaved(false);
      setSelectedId(id);
      onEditOpen();
    } catch (err) {
      console.error('Error in handleEdit:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        stack: err.stack
      });
      toast({
        title: "Error loading vehicle data",
        description: err.message || "Failed to load vehicle data",
        status: "error",
        isClosable: true
      });
    }
  };

  const handleView = (id) => {
    navigate(`/admin/vehicules/${id}`);
  };



  const handleLoc = async (vehicule) => {
    setSelectedId(vehicule);
    const res = await getVehicule(vehicule);
    onlocOpen();
    try {
      const data = {
        // Utiliser le hash depuis la config (variable d'environnement)
        hash: config.navixy.hash,
        tracker_id: res.data.tracker_id,
      };
      const response = await axios.post(
        `${config.navixy.apiUrl}/tracker/get_state`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          // Ne pas envoyer de cookies/credentials vers Navixy pour éviter les erreurs CORS
          withCredentials: false,
        }
      );

      const latitude = response.data.state.gps.location.lat;
      const longitude = response.data.state.gps.location.lng;

      if (latitude && longitude) {
        setLocationData({ lat: latitude, lon: longitude });
      } else {
        console.warn("No location data found for this tracker.");
        setLocationData({ lat: null, lon: null });
      }
    }

    catch (error) {
      console.error("Error fetching tracker location:", error);
      setLocationData({ lat: null, lon: null });
    }
  };

  const handleSave = async () => {
    const userId = editData.user_id;
    const infId = editData.infirmier;

    try {
      const response = await getVehicules();
      const vehicles = response.data;

      // Exclude the current vehicle from the check and only check non-null values
      const vehiclesWithUser = userId ? vehicles.filter(vehicle => vehicle.user_id == userId && vehicle.id != selectedId) : [];
      const vehiclesWithinfId = infId ? vehicles.filter(vehicle => vehicle.infirmier == infId && vehicle.id != selectedId) : [];

      if (vehiclesWithUser.length > 0 || vehiclesWithinfId.length > 0) {
        setReassignData({
          userId,
          infId,
          vehiclesWithUser,
          vehiclesWithinfId
        });
        setReassignConfirm(true);
      } else {
        await updateVehicule(selectedId, editData);

        await fetchData();
        toast({ title: "Updated", status: "success", isClosable: true });
        onEditClose();
      }
    } catch (err) {
      toast({
        title: "Update failed",
        description: err.message || "An error occurred while updating",
        status: "error",
        isClosable: true
      });
    }
  };

  const handleReassign = async () => {
    try {
      // Mise à jour des véhicules avec l'ambulancier
      if (reassignData.vehiclesWithUser.length > 0) {
        await Promise.all(
          reassignData.vehiclesWithUser.map(async vehicle => {
            const res = await getVehicule(vehicle.id);
            const fullVehicle = { ...res.data, user_id: null };
            return updateVehiculesBatch(vehicle.id, fullVehicle);
          })
        );
      }

      // Mise à jour des véhicules avec l'infirmier
      if (reassignData.vehiclesWithinfId.length > 0) {
        await Promise.all(
          reassignData.vehiclesWithinfId.map(async vehicle => {
            const res = await getVehicule(vehicle.id);
            const fullVehicle = { ...res.data, infirmier: null };
            return updateVehiculesBatch(vehicle.id, fullVehicle);
          })
        );
      }

      // Mise à jour du véhicule sélectionné
      await updateVehicule(selectedId, {
        ...editData,
        user_id: reassignData.userId,
        infirmier: reassignData.infId
      });

      await fetchData();
      toast({ title: "Updated", status: "success", isClosable: true });
      onEditClose();
    } catch (err) {
      toast({
        title: "Update failed",
        description: err.message || "An error occurred while updating",
        status: "error",
        isClosable: true
      });
    } finally {
      setReassignConfirm(false);
      setReassignData(null);
    }
  };

  const handleAdd = async () => {
    try {
      await createVehicule(newVehiculeData);
      await fetchData();
      toast({ title: "Added", status: "success", isClosable: true });
      onAddClose();
    } catch (err) {
      console.error('Error adding new vehicle:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        stack: err.stack
      });
      toast({
        title: "Add failed",
        description: err.message || "An error occurred while adding",
        status: "error",
        isClosable: true
      });
    }
  };

  const handleCloseEdit = () => {
    if (JSON.stringify(editData) !== JSON.stringify(initialData)) {
      const confirmClose = window.confirm("Unsaved changes detected. Do you want to discard?");
      if (!confirmClose) return;
    }
    onEditClose();
  };

  const handleRemove = (id) => {
    setSelectedId(id);
    onAlertOpen();
  };

  const confirmDelete = async () => {
    try {
      await deleteVehicule(selectedId);
      await fetchData(); // Reuse the fetchData function instead of reload
      toast({ title: "Deleted", status: "success", isClosable: true });
    } catch (err) {
      toast({
        title: "Delete failed",
        description: err.message || "An error occurred while deleting",
        status: "error",
        isClosable: true
      });
    }
    onAlertClose();
  };

  const updateField = (field, value) => {
    setEditData(prev => ({ ...prev, [field]: value }));
    setUnsaved(true);
  };

  const updateAddField = (field, value) => {
    setNewVehiculeData(prev => ({ ...prev, [field]: value }));
  };

  const truncateText = (text, maxLength = 20) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const handleInventory = async (vehicleId) => {
    try {
      const [materials, usage] = await Promise.all([
        getMateriels(),
        getUtilisationMateriel()
      ]);

      const vehicleMaterials = materials.data.filter((m) => m.ambulance_id == vehicleId);
      const vehicle = tableData.find(v => v.id === vehicleId);

      // Get usage history for this vehicle with joined data
      const vehicleUsage = usage.data.filter((u) => u.ambulance_id == vehicleId);

      // Group usage by mission
      const groupedUsage = vehicleUsage.reduce((acc, usage) => {
        if (!acc[usage.mission_id]) {
          acc[usage.mission_id] = {
            mission_id: usage.mission_id,
            patient: {
              nom: usage.patient_nom,
              prenom: usage.patient_prenom
            },
            mission: {
              date_mission: usage.date_mission
            },
            items: []
          };
        }
        acc[usage.mission_id].items.push(usage);
        return acc;
      }, {});

      // Convert to array format expected by the component
      const usageWithDetails = Object.values(groupedUsage);

      setInventoryData({
        vehicle,
        materials: vehicleMaterials
      });
      setUsageHistory(usageWithDetails);
      onInventoryOpen();
    } catch (err) {
      console.error(err);
      toast({ title: "Error fetching inventory", status: "error", isClosable: true });
    }
  };

  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setSelectedLocation({ lat, lng });
    setLocationData({ lat, lon: lng });
  };

  const handleDispatch = async () => {
    try {
      const dispatchPayload = {
        ambulance_id: selectedId,
        loc: `${locationData.lat},${locationData.lon}`,
        description: dispatchData.description
      };

      await createDispatch(dispatchPayload);

      toast({
        title: "Dispatch créé",
        description: "Le point de dispatch a été enregistré avec succès",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      setDispatchData({
        description: "",
        loc: "",
        ambulance_id: null
      });
      onlocClose();
    } catch (err) {
      console.error('Dispatch Error:', err);
      toast({
        title: "Erreur",
        description: "Erreur lors de la création du dispatch",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  // ==================== MAINTENANCE FUNCTIONS ====================
  const handleMaintenance = async (vehicleId) => {
    try {
      const vehicle = tableData.find(v => v.id === vehicleId);

      setMaintenanceData(vehicle);
      setSelectedId(vehicleId);

      // Fetch maintenance tasks
      const tasksRes = await getMaintenanceTasks(vehicleId);
      setMaintenanceTasks(tasksRes.data);

      onMaintenanceOpen();
    } catch (err) {
      console.error('Error fetching maintenance data:', err);
      toast({
        title: "Erreur",
        description: "Erreur lors du chargement des données de maintenance",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleAddTask = async () => {
    try {
      const user = await getUser();

      const taskPayload = {
        ...newTaskData,
        user_id: user.id
      };

      await createMaintenanceTask(selectedId, taskPayload);

      // Refresh tasks
      const tasksRes = await getMaintenanceTasks(selectedId);
      setMaintenanceTasks(tasksRes.data);

      // Reset form
      setNewTaskData({
        name: "",
        status: "ok",
        next_due_date: "",
        last_performed_at: "",
        notes: "",
        user_id: null
      });

      toast({
        title: "Tâche ajoutée",
        description: "La tâche de maintenance a été créée avec succès",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      onTaskModalClose();
    } catch (err) {
      console.error('Error adding task:', err);
      toast({
        title: "Erreur",
        description: "Erreur lors de la création de la tâche",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleUpdateTask = async (taskId, updatedData) => {
    try {
      await updateMaintenanceTask(selectedId, taskId, updatedData);

      // Refresh tasks
      const tasksRes = await getMaintenanceTasks(selectedId);
      setMaintenanceTasks(tasksRes.data);

      toast({
        title: "Tâche mise à jour",
        description: "La tâche de maintenance a été mise à jour avec succès",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (err) {
      console.error('Error updating task:', err);
      toast({
        title: "Erreur",
        description: "Erreur lors de la mise à jour de la tâche",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleDeleteTask = async (taskId) => {
    try {
      await deleteMaintenanceTask(selectedId, taskId);

      // Refresh tasks
      const tasksRes = await getMaintenanceTasks(selectedId);
      setMaintenanceTasks(tasksRes.data);

      toast({
        title: "Tâche supprimée",
        description: "La tâche de maintenance a été supprimée avec succès",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (err) {
      console.error('Error deleting task:', err);
      toast({
        title: "Erreur",
        description: "Erreur lors de la suppression de la tâche",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const updateTaskField = (field, value) => {
    setNewTaskData(prev => ({ ...prev, [field]: value }));
  };

  // ==================== STATUS CHANGE FUNCTIONS ====================
  const handleStatusChange = async (taskId, newStatus) => {
    try {
      const user = await getUser();

      // Trouver la tâche actuelle
      const currentTask = maintenanceTasks.find(task => task.id === taskId);
      if (!currentTask) {
        throw new Error('Tâche non trouvée');
      }

      // Si on passe à "ok", on doit créer un historique
      if (newStatus === "ok") {
        setStatusChangeData({
          taskId: taskId,
          fromStatus: currentTask.status,
          toStatus: newStatus,
          action: "maintenance_completed",
          odometer_km: "",
          cost_mad: "",
          notes: "",
          next_due_date_set: ""
        });
        setSelectedTask(currentTask);
        onHistoryModalOpen();
        return;
      }

      // Pour les autres changements de statut, on met à jour directement
      await updateMaintenanceTask(selectedId, taskId, { status: newStatus });

      // Créer un historique simple
      const historyPayload = {
        action: "status_changed",
        from_status: currentTask.status,
        to_status: newStatus,
        user_id: user.id,
        notes: `Statut changé de ${currentTask.status} à ${newStatus}`
      };

      await createMaintenanceTaskHistory(selectedId, taskId, historyPayload);

      // Refresh tasks
      const tasksRes = await getMaintenanceTasks(selectedId);
      setMaintenanceTasks(tasksRes.data);

      toast({
        title: "Statut mis à jour",
        description: `Le statut a été changé vers ${newStatus}`,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (err) {
      console.error('Error changing status:', err);
      toast({
        title: "Erreur",
        description: "Erreur lors du changement de statut",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleCompleteMaintenance = async () => {
    try {
      const user = await getUser();

      // Créer l'historique - l'API backend mettra automatiquement à jour la tâche
      const historyPayload = {
        action: "maintenance_completed", // Utiliser le nom complet comme dans votre API
        from_status: statusChangeData.fromStatus,
        to_status: statusChangeData.toStatus,
        next_due_date_set: statusChangeData.next_due_date_set || null,
        odometer_km: parseInt(statusChangeData.odometer_km) || null,
        cost_mad: parseFloat(statusChangeData.cost_mad) || null,
        notes: statusChangeData.notes || "Maintenance complétée",
        user_id: user.id
      };


      // Créer l'historique - l'API backend s'occupe de tout automatiquement
      await createMaintenanceTaskHistory(selectedId, statusChangeData.taskId, historyPayload);

      // Refresh tasks pour récupérer les données mises à jour par l'API
      const tasksRes = await getMaintenanceTasks(selectedId);
      setMaintenanceTasks(tasksRes.data);

      // Reset form
      setStatusChangeData({
        taskId: null,
        fromStatus: "",
        toStatus: "",
        action: "",
        odometer_km: "",
        cost_mad: "",
        notes: "",
        next_due_date_set: ""
      });

      toast({
        title: "Maintenance complétée",
        description: "La maintenance a été marquée comme terminée et ajoutée à l'historique",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      onHistoryModalClose();
    } catch (err) {
      console.error('Error completing maintenance:', err);
      toast({
        title: "Erreur",
        description: "Erreur lors de la finalisation de la maintenance",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const updateStatusChangeField = (field, value) => {
    setStatusChangeData(prev => ({ ...prev, [field]: value }));
  };

  const handleVehicleHistory = async (vehicleId) => {
    try {
      const vehicle = tableData.find(v => v.id === vehicleId);

      setMaintenanceData(vehicle);
      setSelectedId(vehicleId);

      // Fetch consolidated maintenance history for this vehicle
      const historyRes = await getVehicleMaintenanceHistory(vehicleId);
      setVehicleHistory(historyRes.data);

      onVehicleHistoryOpen();
    } catch (err) {
      console.error('Error fetching vehicle history:', err);
      toast({
        title: "Erreur",
        description: "Erreur lors du chargement de l'historique du véhicule",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');
  const topPadding = navbarHeight > 0 ? `${navbarHeight}px` : '200px';

  if (loading) {
    return (
      <Box minH="100vh" bg={bgColor} px={6} pb={6} pt={0}>
        <Box maxW="9xl" mx="auto" pt={topPadding} transition="padding-top 0.3s ease">
          <LoadingSpinner message="Chargement des véhicules..." size="lg" fullHeight />
        </Box>
      </Box>
    );
  }

  return (
    <Box minH="100vh" bg={bgColor} px={6} pb={6} pt={0}>
      <Box maxW="9xl" mx="auto" pt={topPadding} transition="padding-top 0.3s ease">
        <VStack spacing={6} align="stretch">

          {/* Statistics Section */}
          {showStats && (
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={6}>
              <VehicleStatCard
                title="Nombre total de véhicules"
                value={stats.total}
                percentage="+0%"
                subtitle="Growth vs semaine précédente"
                icon={MdDirectionsCar}
                iconColor="#459CE9"
                isPositive={true}
                onClick={() => {
                  setStatusFilter("all");
                  setTypeFilter("all");
                  setSearchTerm("");
                  setCurrentPage(1);
                }}
              />
              <VehicleStatCard
                title="En Service"
                value={stats.enService}
                subtitle="Véhicules disponibles"
                icon={MdCheckCircle}
                iconColor="#29BACD"
                isPositive={true}
                onClick={() => {
                  setStatusFilter("en service");
                  setCurrentPage(1);
                }}
              />
              <VehicleStatCard
                title="En Mission"
                value={stats.enMission}
                subtitle="Véhicules actuellement en mission"
                icon={MdLocationOn}
                iconColor="#F8285A"
                isPositive={true}
                onClick={() => {
                  setStatusFilter("en mission");
                  setCurrentPage(1);
                }}
              />
              <VehicleStatCard
                title="En Maintenance"
                value={stats.enMaintenance}
                subtitle="Véhicules en maintenance"
                icon={MdWarning}
                iconColor="#F8285A"
                isPositive={false}
                onClick={() => {
                  setStatusFilter("en maintenance");
                  setCurrentPage(1);
                }}
              />
            </SimpleGrid>
          )}

          {/* Filters Section */}
          <Box bg={cardBg} borderRadius="12px" p={4} mb={4}>
            <Flex
              direction={{ base: "column", xl: "row" }}
              gap={4}
              align={{ base: "stretch", xl: "center" }}
              justify="space-between"
            >
              {/* Type Filters with horizontal scroll if needed */}
              <Box
                overflowX="auto"
                pb={{ base: 2, xl: 0 }}
                css={{
                  '&::-webkit-scrollbar': { display: 'none' },
                  'msOverflowStyle': 'none',
                  'scrollbarWidth': 'none',
                }}
              >
                <Flex
                  bg="#F4F7FE"
                  p="4px"
                  borderRadius="12px"
                  w="fit-content"
                  gap="2px"
                  border="1px solid"
                  borderColor="gray.100"
                  flexShrink={0}
                >
                  {Object.keys(typeCounts)
                    .sort((a, b) => a === 'all' ? -1 : b === 'all' ? 1 : a.localeCompare(b))
                    .map((type) => {
                      const isActive = typeFilter === type;
                      const count = typeCounts[type];
                      const label = type === 'all' ? 'Tout' : type;

                      return (
                        <Flex
                          key={type}
                          px="20px"
                          py="8px"
                          borderRadius="10px"
                          bg={isActive ? "white" : "transparent"}
                          boxShadow={isActive ? "0px 4px 12px rgba(0,0,0,0.05)" : "none"}
                          cursor="pointer"
                          onClick={() => {
                            setTypeFilter(type);
                            setCurrentPage(1);
                          }}
                          align="center"
                          gap="12px"
                          transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
                          _hover={!isActive ? { bg: "rgba(0,0,0,0.04)" } : {}}
                        >
                          <Text
                            fontSize="15px"
                            fontWeight="700"
                            color={isActive ? "#1B31C4" : "#707EAE"}
                            whiteSpace="nowrap"
                          >
                            {label}
                          </Text>
                          {type !== 'all' && (
                            <Text
                              fontSize="14px"
                              fontWeight="600"
                              color="#A3AED0"
                            >
                              {count.toString().padStart(2, '0')}
                            </Text>
                          )}
                        </Flex>
                      );
                    })}
                </Flex>
              </Box>

              {/* Search and Controls */}
              <Flex gap={4} align="center" flex={{ base: "none", xl: "1" }} justify="flex-end" flexWrap="nowrap">
                <InputGroup maxW={{ base: "full", xl: "350px" }} minW="200px">
                  <InputLeftElement pointerEvents="none">
                    <Icon as={MdSearch} color="gray.400" />
                  </InputLeftElement>
                  <Input
                    placeholder="Recherche d'un véhicule..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                    bg="white"
                    borderRadius="md"
                    size="sm"
                  />
                </InputGroup>

                <Select
                  value={statusFilter}
                  onChange={(e) => {
                    setStatusFilter(e.target.value);
                    setCurrentPage(1);
                  }}
                  maxW="160px"
                  size="sm"
                  bg="white"
                  borderRadius="md"
                >
                  <option value="all">Statut: Tous</option>
                  <option value="en service">En Service / Dispo</option>
                  <option value="en mission">En Mission</option>
                  <option value="en maintenance">En Maintenance</option>
                  <option value="hors service">Hors Service</option>
                  <option value="inactif">Inactif</option>
                </Select>
                <HStack spacing={2} flexShrink={0}>
                  <IconButton
                    icon={<MdGridView />}
                    aria-label="Vue grille"
                    size="sm"
                    variant={viewMode === "grid" ? "solid" : "outline"}
                    colorScheme={viewMode === "grid" ? "blue" : "gray"}
                    onClick={() => setViewMode("grid")}
                  />
                  <IconButton
                    icon={<MdList />}
                    aria-label="Vue liste"
                    size="sm"
                    variant={viewMode === "list" ? "solid" : "outline"}
                    colorScheme={viewMode === "list" ? "blue" : "gray"}
                    onClick={() => setViewMode("list")}
                  />
                </HStack>
              </Flex>
            </Flex>
          </Box>

          {/* Table/Grid Section */}
          <Box bg={cardBg} borderRadius="12px" p={6}>
            {viewMode === "list" ? (
              <TableContainer border="1px solid" borderColor="gray.200" borderRadius="12px" overflowX="auto">
                <Table variant="simple" minW="1300px" sx={{ 'th, td': { borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'gray.200', whiteSpace: 'nowrap' }, 'th:last-child, td:last-child': { borderRight: 'none' }, 'tr:last-child td': { borderBottom: 'none' } }}>
                  <Thead>
                    <Tr bg="gray.50">
                      <Th w="90px">Immatriculation</Th>
                      <Th w="100px">Type</Th>
                      <Th w="200px">Ambulancier</Th>
                      <Th w="200px">Infirmier</Th>
                      <Th w="120px">Kilométrage</Th>
                      <Th w="100px">Statut</Th>
                      <Th w="102px">Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {paginatedData.length === 0 ? (
                      <Tr>
                        <Td colSpan={10} textAlign="center" py={8}>
                          <Text color="gray.500">Aucun véhicule trouvé</Text>
                        </Td>
                      </Tr>
                    ) : (
                      paginatedData.map((row) => {
                        return (
                          <Tr key={row.id} _hover={{ bg: "gray.50", cursor: "pointer" }}>

                            <Td fontWeight="medium">{row.immatriculation || '---'}</Td>
                            <Td>{formatVehicleType(row.type_vehicule)}</Td>
                            <Td>{row.ambulancierName || '---'}</Td>
                            <Td>{row.infirmierName || '---'}</Td>
                            <Td>{row.km ? `${row.km} km` : '---'}</Td>
                            <Td>
                              <StatusBadge status={row.statut || '---'} />
                            </Td>
                            <Td onClick={(e) => e.stopPropagation()}>
                              <Menu>
                                <MenuButton
                                  as={IconButton}
                                  icon={<MdMoreVert />}
                                  variant="ghost"
                                  size="sm"
                                  aria-label="Actions"
                                />
                                <MenuList>
                                  <MenuItem icon={<MdLocationOn />} onClick={() => handleLoc(row.id)}>
                                    Localisation
                                  </MenuItem>
                                  <MenuItem icon={<MdVisibility />} onClick={() => handleView(row.id)}>
                                    Voir
                                  </MenuItem>
                                  {hasPermission('vehicules_edit') && (<MenuItem icon={<MdEdit />} onClick={() => handleEdit(row.id)}>
                                    Modifier
                                  </MenuItem>)}
                                  <MenuItem icon={<MdHomeRepairService />} onClick={() => handleInventory(row.id)}>
                                    Inventaire
                                  </MenuItem>
                                  <MenuItem icon={<MdBuild />} onClick={() => handleMaintenance(row.id)}>
                                    Maintenance
                                  </MenuItem>
                                  <MenuItem icon={<Icon as={MdError} />} onClick={() => handleVehicleHistory(row.id)}>
                                    Historique
                                  </MenuItem>
                                  {hasPermission('vehicules_delete') && (<MenuItem icon={<MdDelete />} onClick={() => handleRemove(row.id)} color="red.500">
                                    Supprimer
                                  </MenuItem>)}
                                </MenuList>
                              </Menu>
                            </Td>
                          </Tr>
                        );
                      })
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            ) : (
              <Box p={4}>
                {paginatedData.length === 0 ? (
                  <Box textAlign="center" py={12}>
                    <Text color="gray.500" fontSize="lg">Aucun véhicule trouvé</Text>
                  </Box>
                ) : (
                  <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 4 }} spacing={4}>
                    {paginatedData.map((row) => {
                      return (
                        <Card
                          key={row.id}
                          bg="white"
                          borderRadius="12px"
                          border="1px solid"
                          borderColor="#E5E5E5"
                          p={4}
                          _hover={{
                            boxShadow: '0px 3px 4px 0px rgba(0,0,0,0.03)',
                            transform: 'translateY(-2px)',
                            borderColor: '#459CE9'
                          }}
                          transition="all 0.2s"
                          position="relative"
                          zIndex={1}
                          _focusWithin={{ zIndex: 10 }}
                        >
                          <VStack align="stretch" spacing={3}>
                            <Flex justify="space-between" align="start">
                              <Checkbox
                                isChecked={selectedVehicles.includes(row.id)}
                                onChange={() => {
                                  setSelectedVehicles(prev =>
                                    prev.includes(row.id)
                                      ? prev.filter(id => id !== row.id)
                                      : [...prev, row.id]
                                  );
                                }}
                              />
                              <Menu>
                                <MenuButton
                                  as={IconButton}
                                  icon={<MdMoreVert />}
                                  variant="ghost"
                                  size="sm"
                                  aria-label="Actions"
                                />
                                <MenuList zIndex={1000} boxShadow="0px 4px 12px 0px rgba(0,0,0,0.15)">
                                  <MenuItem icon={<MdLocationOn />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleLoc(row.id);
                                  }}>
                                    Localisation
                                  </MenuItem>
                                  <MenuItem icon={<MdVisibility />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleView(row.id);
                                  }}>
                                    Voir
                                  </MenuItem>
                                  {hasPermission('vehicules_edit') && (<MenuItem icon={<MdEdit />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit(row.id);
                                  }}>
                                    Modifier
                                  </MenuItem>)}
                                  <MenuItem icon={<MdHomeRepairService />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleInventory(row.id);
                                  }}>
                                    Inventaire
                                  </MenuItem>
                                  <MenuItem icon={<MdBuild />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleMaintenance(row.id);
                                  }}>
                                    Maintenance
                                  </MenuItem>
                                  <MenuItem icon={<Icon as={MdError} />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleVehicleHistory(row.id);
                                  }}>
                                    Historique
                                  </MenuItem>
                                  {hasPermission('vehicules_delete') && (<MenuItem icon={<MdDelete />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemove(row.id);
                                  }} color="red.500">
                                    Supprimer
                                  </MenuItem>)}
                                </MenuList>
                              </Menu>
                            </Flex>

                            <VStack spacing={1} align="center">
                              <Icon as={MdDirectionsCar} w="40px" h="40px" color="#459CE9" />
                              <Text fontSize="lg" fontWeight="bold" color="gray.900">
                                {row.immatriculation || '---'}
                              </Text>
                              <Text fontSize="sm" color="gray.600">
                                {formatVehicleType(row.type_vehicule)}
                              </Text>
                            </VStack>

                            <Divider />

                            <VStack align="stretch" spacing={2}>
                              <HStack justify="space-between">
                                <Text fontSize="xs" color="gray.500">Ambulancier</Text>
                                <Text fontSize="sm" fontWeight="medium">{row.ambulancierName || '---'}</Text>
                              </HStack>
                              <HStack justify="space-between">
                                <Text fontSize="xs" color="gray.500">Infirmier</Text>
                                <Text fontSize="sm" fontWeight="medium">{row.infirmierName || '---'}</Text>
                              </HStack>
                              <HStack justify="space-between">
                                <Text fontSize="xs" color="gray.500">Kilométrage</Text>
                                <Text fontSize="sm" fontWeight="bold" color="#455879">
                                  {row.km ? `${row.km} km` : '---'}
                                </Text>
                              </HStack>
                              <HStack justify="space-between" pt={2}>
                                <Badge
                                  colorScheme={
                                    (row.statut || '').toLowerCase() === 'en service' || (row.statut || '').toLowerCase() === 'disponible' ? 'green' :
                                      (row.statut || '').toLowerCase() === 'en mission' ? 'blue' :
                                        (row.statut || '').toLowerCase() === 'maintenance' || (row.statut || '').toLowerCase() === 'en maintenance' ? 'orange' : 'gray'
                                  }
                                  borderRadius="full"
                                  px={3}
                                  py={1}
                                >
                                  • {row.statut || '---'}
                                </Badge>
                                <HStack spacing={2}>
                                  <IconButton
                                    icon={<MdLocationOn />}
                                    aria-label="Localisation"
                                    size="xs"
                                    variant="ghost"
                                    onClick={() => handleLoc(row.id)}
                                  />
                                  <IconButton
                                    icon={<MdVisibility />}
                                    aria-label="Voir"
                                    size="xs"
                                    variant="ghost"
                                    onClick={() => handleView(row.id)}
                                  />
                                  <IconButton
                                    icon={<MdEdit />}
                                    aria-label="Modifier"
                                    size="xs"
                                    variant="ghost"
                                    onClick={() => handleEdit(row.id)}
                                  />
                                </HStack>
                              </HStack>
                            </VStack>
                          </VStack>
                        </Card>
                      );
                    })}
                  </SimpleGrid>
                )}
              </Box>
            )}

            {/* Pagination */}
            {paginatedData.length > 0 && (
              <Flex justify="space-between" align="center" p={4} borderTop="1px solid" borderColor="gray.200">
                <HStack spacing={2}>
                  <Text fontSize="sm" color="gray.600">Afficher</Text>
                  <Select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    w="100px"
                    size="sm"
                    bg="white"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Select>
                  <Text fontSize="sm" color="gray.600">par page</Text>
                </HStack>
                <Text fontSize="sm" color="gray.600">
                  {startIndex + 1} à {Math.min(endIndex, filteredData.length)} sur {filteredData.length}
                </Text>
                <HStack spacing={2}>
                  <IconButton
                    icon={<MdChevronLeft />}
                    aria-label="Page précédente"
                    size="sm"
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    isDisabled={currentPage === 1}
                  />
                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }
                    return (
                      <Button
                        key={pageNum}
                        size="sm"
                        variant={currentPage === pageNum ? "solid" : "outline"}
                        colorScheme={currentPage === pageNum ? "blue" : "gray"}
                        onClick={() => setCurrentPage(pageNum)}
                      >
                        {pageNum}
                      </Button>
                    );
                  })}
                  <IconButton
                    icon={<MdChevronRight />}
                    aria-label="Page suivante"
                    size="sm"
                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                    isDisabled={currentPage === totalPages}
                  />
                </HStack>
              </Flex>
            )}
          </Box>
        </VStack>
      </Box >

      {/* Delete Confirmation */}
      < AlertDialog isOpen={isAlertOpen} leastDestructiveRef={cancelRef} onClose={onAlertClose} >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Confirmer la suppression</AlertDialogHeader>
            <AlertDialogBody>Êtes-vous sûr de vouloir supprimer ce véhicule ?</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onAlertClose}>Annuler</Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>Supprimer</Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog >

      {/* Reassign Confirmation */}
      < AlertDialog isOpen={reassignConfirm} leastDestructiveRef={cancelRef} onClose={() => setReassignConfirm(false)
      }>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Confirmer la réassignation</AlertDialogHeader>
            <AlertDialogBody>
              L'utilisateur est déjà assigné à d'autres véhicules. Voulez-vous le retirer de ces véhicules et l'assigner au nouveau véhicule ?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={() => setReassignConfirm(false)}>
                Annuler
              </Button>
              <Button colorScheme="blue" onClick={handleReassign} ml={3}>
                Confirmer
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog >

      {/* Edit Modal */}
      < Modal isOpen={isEditOpen} onClose={handleCloseEdit} size="3xl" >
        <ModalOverlay />
        <ModalContent maxW="900px">
          <ModalHeader>Modifier le Véhicule</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {editData && (
              <SimpleGrid columns={2} spacing={8}>
                {/* Colonne gauche : infos principales */}
                <Box bg="gray.50" p={6} borderRadius="lg">
                  <Text fontSize="lg" fontWeight="bold" color="blue.500" mb={4}>Informations Générales</Text>
                  <VStack align="start" spacing={3}>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Immatriculation</FormLabel>
                      <Input
                        value={editData.immatriculation}
                        onChange={(e) => updateField("immatriculation", e.target.value)}
                        fontSize="md"
                        color="gray.800"
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Type</FormLabel>
                      <Select
                        value={editData?.type_vehicule || ""}
                        onChange={(e) => updateField("type_vehicule", e.target.value)}
                        fontSize="md"
                        color="gray.800"
                      >
                        <option value="tas">TAS</option>
                        <option value="tar">TAR</option>
                      </Select>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Statut</FormLabel>
                      <Select
                        value={editData.statut}
                        onChange={(e) => updateField("statut", e.target.value)}
                        fontSize="md"
                        color="gray.800"
                      >
                        <option value="disponible">disponible</option>
                        <option value="en mission">en mission</option>
                        <option value="entretien">entretien</option>
                      </Select>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Ville</FormLabel>
                      <Select
                        value={editData.ville}
                        onChange={(e) => updateField("ville", e.target.value)}
                        fontSize="md"
                        color="gray.800"
                      >
                        <option value="Agadir">Agadir</option>
                        <option value="Agdz">Agdz</option>
                        <option value="Aït Melloul">Aït Melloul</option>
                        <option value="Al Hoceïma">Al Hoceïma</option>
                        <option value="Arfoud">Arfoud</option>
                        <option value="Asilah">Asilah</option>
                        <option value="Azemmour">Azemmour</option>
                        <option value="Azrou">Azrou</option>
                        <option value="Beni Mellal">Beni Mellal</option>
                        <option value="Ben Guerir">Ben Guerir</option>
                        <option value="Berkane">Berkane</option>
                        <option value="Berrechid">Berrechid</option>
                        <option value="Bouarfa">Bouarfa</option>
                        <option value="Boujdour">Boujdour</option>
                        <option value="Boulemane">Boulemane</option>
                        <option value="Bouskoura">Bouskoura</option>
                        <option value="Casablanca">Casablanca</option>
                        <option value="Chefchaouen">Chefchaouen</option>
                        <option value="Chichaoua">Chichaoua</option>
                        <option value="Dakhla">Dakhla</option>
                        <option value="Demnate">Demnate</option>
                        <option value="Drarga">Drarga</option>
                        <option value="El Hajeb">El Hajeb</option>
                        <option value="El Jadida">El Jadida</option>
                        <option value="El Jorf Lasfar">El Jorf Lasfar</option>
                        <option value="Errachidia">Errachidia</option>
                        <option value="Essaouira">Essaouira</option>
                        <option value="Fès">Fès</option>
                        <option value="Fnideq">Fnideq</option>
                        <option value="Guelmim">Guelmim</option>
                        <option value="Guercif">Guercif</option>
                        <option value="Ifrane">Ifrane</option>
                        <option value="Imzouren">Imzouren</option>
                        <option value="Inezgane">Inezgane</option>
                        <option value="Jerada">Jerada</option>
                        <option value="Jorf El Melha">Jorf El Melha</option>
                        <option value="Kénitra">Kénitra</option>
                        <option value="Khémisset">Khémisset</option>
                        <option value="Khénifra">Khénifra</option>
                        <option value="Khouribga">Khouribga</option>
                        <option value="Ksar El Kebir">Ksar El Kebir</option>
                        <option value="Laâyoune">Laâyoune</option>
                        <option value="Larache">Larache</option>
                        <option value="Lqliaa">Lqliaa</option>
                        <option value="Marrakech">Marrakech</option>
                        <option value="Martil">Martil</option>
                        <option value="Meknès">Meknès</option>
                        <option value="Midelt">Midelt</option>
                        <option value="Mohammédia">Mohammédia</option>
                        <option value="Nador">Nador</option>
                        <option value="Nouaceur">Nouaceur</option>
                        <option value="Ouarzazate">Ouarzazate</option>
                        <option value="Oued Zem">Oued Zem</option>
                        <option value="Oujda">Oujda</option>
                        <option value="Oulad Teima">Oulad Teima</option>
                        <option value="Rabat">Rabat</option>
                        <option value="Rissani">Rissani</option>
                        <option value="Rommani">Rommani</option>
                        <option value="Safi">Safi</option>
                        <option value="Salé">Salé</option>
                        <option value="Sefrou">Sefrou</option>
                        <option value="Settat">Settat</option>
                        <option value="Sidi Bennour">Sidi Bennour</option>
                        <option value="Sidi Ifni">Sidi Ifni</option>
                        <option value="Sidi Kacem">Sidi Kacem</option>
                        <option value="Sidi Slimane">Sidi Slimane</option>
                        <option value="Skhirat">Skhirat</option>
                        <option value="Tafraout">Tafraout</option>
                        <option value="Tan-Tan">Tan-Tan</option>
                        <option value="Tanger">Tanger</option>
                        <option value="Taourirt">Taourirt</option>
                        <option value="Tarfaya">Tarfaya</option>
                        <option value="Taroudant">Taroudant</option>
                        <option value="Taza">Taza</option>
                        <option value="Témara">Témara</option>
                        <option value="Tétouan">Tétouan</option>
                        <option value="Tiflet">Tiflet</option>
                        <option value="Youssoufia">Youssoufia</option>
                        <option value="Tiznit">Tiznit</option>
                        <option value="Zagora">Zagora</option>
                      </Select>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Tracker</FormLabel>
                      <Input
                        type="number"
                        value={editData.tracker_id}
                        isReadOnly
                        fontSize="md"
                        color="gray.800"
                        bg="gray.100"
                        cursor="not-allowed"
                      />
                    </FormControl>
                  </VStack>
                </Box>
                {/* Colonne droite : affectations et entretiens */}
                <Box bg="gray.50" p={6} borderRadius="lg">
                  <Text fontSize="lg" fontWeight="bold" color="blue.500" mb={4}>Affectations & Entretien</Text>
                  <VStack align="start" spacing={3}>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Ambulancier</FormLabel>
                      <Select
                        value={editData.user_id || ""}
                        onChange={(e) => updateField("user_id", e.target.value || null)}
                        fontSize="md"
                        color="gray.800"
                      >
                        <option value="">Aucun ambulancier</option>
                        {ambulanciers.map((user) => (
                          <option key={user.id} value={user.id}>
                            {user.nom} {user.prenom}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Infirmier</FormLabel>
                      <Select
                        value={editData.infirmier || ""}
                        onChange={(e) => updateField("infirmier", e.target.value || null)}
                        fontSize="md"
                        color="gray.800"
                      >
                        <option value="">Aucun infirmier</option>
                        {infirmiers.map((user) => (
                          <option key={user.id} value={user.id}>
                            {user.nom} {user.prenom}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Dernier Entretien</FormLabel>
                      <Input
                        type="date"
                        value={editData.dernier_entretien}
                        onChange={(e) => updateField("dernier_entretien", e.target.value || null)}
                        fontSize="md"
                        color="gray.800"
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Prochain Entretien</FormLabel>
                      <Input
                        type="date"
                        value={editData.next_entretien}
                        onChange={(e) => updateField("next_entretien", e.target.value || null)}
                        fontSize="md"
                        color="gray.800"
                      />
                    </FormControl>
                  </VStack>
                </Box>
              </SimpleGrid>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleSave}>
              Sauvegarder
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >

      {/* Add Modal */}
      < Modal isOpen={isAddOpen} onClose={onAddClose} >
        <ModalOverlay />
        <ModalContent maxWidth="800px" overflow="hidden">
          <ModalHeader>Ajouter une ambulance
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>


              <FormControl>
                <FormLabel>Immatriculation</FormLabel>
                <Input
                  value={newVehiculeData.immatriculation}
                  onChange={(e) => updateAddField("immatriculation", e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Type</FormLabel>
                <Select
                  value={newVehiculeData.type_vehicule}
                  onChange={(e) => updateAddField("type_vehicule", e.target.value)}
                >
                  <option value="tas">TAS</option>
                  <option value="tar">TAR</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Statut</FormLabel>
                <Select
                  value={newVehiculeData.statut}
                  onChange={(e) => updateAddField("statut", e.target.value)}
                >
                  <option value="disponible">disponible</option>
                  <option value="en mission">en mission</option>
                  <option value="entretien">entretien</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>tracker_id</FormLabel>
                <Input
                  type="number"
                  value={newVehiculeData.tracker_id}
                  onChange={(e) => updateAddField("tracker_id", e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Dernier Entretien</FormLabel>
                <Input
                  type="date"
                  value={newVehiculeData.dernier_entretien || ""}
                  onChange={(e) => updateAddField("dernier_entretien", e.target.value || null)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Prochain Entretien</FormLabel>
                <Input
                  type="date"
                  value={newVehiculeData.next_entretien || ""}
                  onChange={(e) => updateAddField("next_entretien", e.target.value || null)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Ville</FormLabel>
                <Select
                  value={newVehiculeData.ville}
                  onChange={(e) => updateAddField("ville", e.target.value)}
                >
                  <option value="Agadir">Agadir</option>
                  <option value="Agdz">Agdz</option>
                  <option value="Aït Melloul">Aït Melloul</option>
                  <option value="Al Hoceïma">Al Hoceïma</option>
                  <option value="Arfoud">Arfoud</option>
                  <option value="Asilah">Asilah</option>
                  <option value="Azemmour">Azemmour</option>
                  <option value="Azrou">Azrou</option>
                  <option value="Beni Mellal">Beni Mellal</option>
                  <option value="Ben Guerir">Ben Guerir</option>
                  <option value="Berkane">Berkane</option>
                  <option value="Berrechid">Berrechid</option>
                  <option value="Bouarfa">Bouarfa</option>
                  <option value="Boujdour">Boujdour</option>
                  <option value="Boulemane">Boulemane</option>
                  <option value="Bouskoura">Bouskoura</option>
                  <option value="Casablanca">Casablanca</option>
                  <option value="Chefchaouen">Chefchaouen</option>
                  <option value="Chichaoua">Chichaoua</option>
                  <option value="Dakhla">Dakhla</option>
                  <option value="Demnate">Demnate</option>
                  <option value="Drarga">Drarga</option>
                  <option value="El Hajeb">El Hajeb</option>
                  <option value="El Jadida">El Jadida</option>
                  <option value="Errachidia">Errachidia</option>
                  <option value="Essaouira">Essaouira</option>
                  <option value="El Jorf Lasfar">El Jorf Lasfar</option>
                  <option value="Fès">Fès</option>
                  <option value="Fnideq">Fnideq</option>
                  <option value="Guelmim">Guelmim</option>
                  <option value="Guercif">Guercif</option>
                  <option value="Ifrane">Ifrane</option>
                  <option value="Imzouren">Imzouren</option>
                  <option value="Inezgane">Inezgane</option>
                  <option value="Jerada">Jerada</option>
                  <option value="Jorf El Melha">Jorf El Melha</option>
                  <option value="Kénitra">Kénitra</option>
                  <option value="Khémisset">Khémisset</option>
                  <option value="Khénifra">Khénifra</option>
                  <option value="Khouribga">Khouribga</option>
                  <option value="Ksar El Kebir">Ksar El Kebir</option>
                  <option value="Laâyoune">Laâyoune</option>
                  <option value="Larache">Larache</option>
                  <option value="Lqliaa">Lqliaa</option>
                  <option value="Marrakech">Marrakech</option>
                  <option value="Martil">Martil</option>
                  <option value="Meknès">Meknès</option>
                  <option value="Midelt">Midelt</option>
                  <option value="Mohammédia">Mohammédia</option>
                  <option value="Nador">Nador</option>
                  <option value="Nouaceur">Nouaceur</option>
                  <option value="Ouarzazate">Ouarzazate</option>
                  <option value="Oued Zem">Oued Zem</option>
                  <option value="Oujda">Oujda</option>
                  <option value="Oulad Teima">Oulad Teima</option>
                  <option value="Rabat">Rabat</option>
                  <option value="Rissani">Rissani</option>
                  <option value="Rommani">Rommani</option>
                  <option value="Safi">Safi</option>
                  <option value="Salé">Salé</option>
                  <option value="Sefrou">Sefrou</option>
                  <option value="Settat">Settat</option>
                  <option value="Sidi Bennour">Sidi Bennour</option>
                  <option value="Sidi Ifni">Sidi Ifni</option>
                  <option value="Sidi Kacem">Sidi Kacem</option>
                  <option value="Sidi Slimane">Sidi Slimane</option>
                  <option value="Skhirat">Skhirat</option>
                  <option value="Tafraout">Tafraout</option>
                  <option value="Tan-Tan">Tan-Tan</option>
                  <option value="Tanger">Tanger</option>
                  <option value="Taourirt">Taourirt</option>
                  <option value="Tarfaya">Tarfaya</option>
                  <option value="Taroudant">Taroudant</option>
                  <option value="Taza">Taza</option>
                  <option value="Témara">Témara</option>
                  <option value="Tétouan">Tétouan</option>
                  <option value="Tiflet">Tiflet</option>
                  <option value="Youssoufia">Youssoufia</option>
                  <option value="Tiznit">Tiznit</option>
                  <option value="Zagora">Zagora</option>
                </Select>
              </FormControl>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleAdd}>
              Ajouter
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >

      {/* view Modal */}
      < Modal isOpen={isviewOpen} onClose={onviewClose} >
        <ModalOverlay />
        <ModalContent maxWidth="800px" overflow="hidden">
          <ModalHeader>
            <HStack spacing={4} align="center">
              <Text fontSize="2xl" fontWeight="bold">Détails du véhicule</Text>
              <Badge
                colorScheme={
                  viewData?.statut === "disponible" ? "green" :
                    viewData?.statut === "en mission" ? "yellow" :
                      viewData?.statut === "entretien" ? "red" : "gray"
                }
                fontSize="md"
                px={3}
                py={1}
                borderRadius="full"
              >
                {viewData?.statut}
              </Badge>
            </HStack>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {viewData && (
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
                {/* Informations du Véhicule */}
                <Box bg="gray.50" p={4} borderRadius="lg">
                  <Text fontSize="lg" fontWeight="bold" color="blue.500" mb={4}>Informations du Véhicule</Text>
                  <SimpleGrid columns={2} spacing={4}>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Immatriculation</Text>
                      <Text>{viewData.immatriculation}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Type</Text>
                      <Text>{viewData.type_vehicule}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Tracker ID</Text>
                      <Text>{viewData.tracker_id}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Kilométrage</Text>
                      <Text>{viewData.km}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Carburant</Text>
                      <Text>{viewData.gas}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Ville</Text>
                      <Text>{viewData.ville}</Text>
                    </Box>
                  </SimpleGrid>
                </Box>

                {/* Informations de l'Équipage */}
                <Box bg="gray.50" p={4} borderRadius="lg">
                  <Text fontSize="lg" fontWeight="bold" color="blue.500" mb={4}>Informations de l'Équipage</Text>
                  <SimpleGrid columns={2} spacing={4}>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Ambulancier</Text>
                      <Text>{viewData.ambulancierName}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Infirmier</Text>
                      <Text>{viewData.infirmierName}</Text>
                    </Box>
                  </SimpleGrid>
                </Box>

                {/* Informations d'Entretien */}
                <Box bg="gray.50" p={4} borderRadius="lg">
                  <Text fontSize="lg" fontWeight="bold" color="blue.500" mb={4}>Informations d'Entretien</Text>
                  <SimpleGrid columns={2} spacing={4}>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Dernier Entretien</Text>
                      <Text>{viewData.dernier_entretien && new Date(viewData.dernier_entretien).toLocaleDateString("fr-FR")}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="semibold" color="gray.600">Prochain Entretien</Text>
                      <Text>{viewData.next_entretien && new Date(viewData.next_entretien).toLocaleDateString("fr-FR")}</Text>
                    </Box>
                  </SimpleGrid>
                </Box>
              </SimpleGrid>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onviewClose}>
              Fermer
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >



      {/* loc Modal */}
      < Modal isOpen={islocOpen} onClose={closeLocModal} >
        <ModalOverlay />
        <ModalContent maxWidth="800px" overflow="hidden">
          <ModalHeader>Localisation du véhicule</ModalHeader>
          <ModalCloseButton onClick={closeLocModal} />

          <ModalBody>
            {locationData.lat && locationData.lon ? (
              <>
                <Box height="400px" mb={4} position="relative">
                  <Box
                    ref={mapRef}
                    width="100%"
                    height="100%"
                    borderRadius="md"
                    overflow="hidden"
                  />
                </Box>
                <FormControl>
                  <FormLabel>Description du point de dispatch</FormLabel>
                  <Input
                    value={dispatchData.description}
                    onChange={(e) => setDispatchData(prev => ({
                      ...prev,
                      description: e.target.value
                    }))}
                    placeholder="Entrez une description pour ce point"
                  />
                </FormControl>
                <Text mt={2} fontSize="sm" color="gray.500">
                  Faites glisser le marqueur rouge pour sélectionner le point de dispatch
                </Text>
              </>
            ) : (
              <Text>Location not available for this vehicle.</Text>
            )}
          </ModalBody>
          <ModalFooter>
            {locationData.lat && locationData.lon && (
              <Button
                colorScheme="blue"
                onClick={handleDispatch}
                isDisabled={!dispatchData.description || !selectedLocation}
              >
                Dispatch
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal >

      {/* Inventory Modal */}
      < Modal isOpen={isInventoryOpen} onClose={onInventoryClose} size="3xl" >
        <ModalOverlay />
        <ModalContent maxW="1100px">
          <ModalHeader>Gestion des Matériels</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {inventoryData && (() => {
              const groupedMaterials = groupMaterialsByCategory(inventoryData.materials);
              const mainKeys = ["consommable", "dispositif", "pharmacie"];

              const renderMaterialColumn = (catKey) => {
                const list = groupedMaterials[catKey] || [];
                return (
                  <Box
                    key={catKey}
                    bg="white"
                    p={4}
                    borderRadius="md"
                    border="1px solid"
                    borderColor="gray.200"
                    minH="120px"
                  >
                    <Text fontWeight="bold" fontSize="sm" color="blue.600" mb={3} textTransform="uppercase" letterSpacing="0.02em">
                      {MATERIEL_CATEGORY_LABELS[catKey]}
                    </Text>
                    <SimpleGrid columns={2} spacing={2} fontWeight="semibold" color="gray.500" fontSize="xs" mb={2}>
                      <Text>Item</Text>
                      <Text>Qté</Text>
                    </SimpleGrid>
                    {list.length === 0 ? (
                      <Text fontSize="sm" color="gray.500">Aucun article</Text>
                    ) : (
                      list.map((material, idx) => (
                        <SimpleGrid columns={2} spacing={2} key={material.id ?? `${catKey}-${idx}`} alignItems="center" py={1}>
                          <Text fontSize="sm" color="gray.700">{material.item}</Text>
                          <Text fontSize="sm" color="gray.700" fontWeight="600">{material.quantite}</Text>
                        </SimpleGrid>
                      ))
                    )}
                  </Box>
                );
              };

              const renderUsageCategoryBlock = (catKey, items) => {
                if (!items || items.length === 0) return null;
                return (
                  <Box key={catKey} mt={3} pl={2} borderLeft="3px solid" borderColor="blue.200">
                    <Text fontSize="xs" fontWeight="bold" color="gray.600" mb={2}>
                      {MATERIEL_CATEGORY_LABELS[catKey]}
                    </Text>
                    <SimpleGrid columns={2} spacing={2} fontWeight="semibold" color="gray.500" fontSize="xs" mb={1}>
                      <Text>Item</Text>
                      <Text>Qté utilisée</Text>
                    </SimpleGrid>
                    {items.map((row, itemIndex) => (
                      <SimpleGrid columns={2} spacing={2} key={itemIndex} alignItems="center">
                        <Text fontSize="sm" color="gray.700">{row.item}</Text>
                        <Text fontSize="sm" color="gray.700">{row.quantite_utilisee}</Text>
                      </SimpleGrid>
                    ))}
                  </Box>
                );
              };

              return (
                <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={8}>
                  <Box bg="gray.50" p={6} borderRadius="lg">
                    <Text fontSize="lg" fontWeight="bold" color="blue.500" mb={4}>
                      Matériels du véhicule {inventoryData.vehicle?.immatriculation}
                    </Text>
                    <Text fontSize="sm" color="gray.600" mb={4}>
                      Consommable, Dispositif et Pharmacie : chaque article est classé selon son type.
                    </Text>
                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                      {mainKeys.map((k) => renderMaterialColumn(k))}
                    </SimpleGrid>
                    {(groupedMaterials.autre || []).length > 0 && (
                      <Box mt={4}>
                        {renderMaterialColumn("autre")}
                      </Box>
                    )}
                  </Box>

                  <Box bg="gray.50" p={6} borderRadius="lg" maxH="70vh" overflowY="auto">
                    <Text fontSize="lg" fontWeight="bold" color="blue.500" mb={4}>
                      Utilisation des Matériels
                    </Text>
                    {usageHistory.length > 0 ? (
                      <Box>
                        {usageHistory.map((missionGroup, index) => {
                          const groupedUsage = groupUsageItemsByCategory(
                            missionGroup.items,
                            inventoryData.materials
                          );
                          return (
                            <Box key={index} p={4} borderWidth="1px" borderRadius="md" mb={4} bg="white">
                              <Text fontWeight="bold" mb={2} color="gray.700">
                                Mission #{missionGroup.mission_id}
                              </Text>
                              {missionGroup.patient && (
                                <Text mb={2} color="gray.600">
                                  Patient: {missionGroup.patient.nom} {missionGroup.patient.prenom}
                                </Text>
                              )}
                              {missionGroup.mission && (
                                <Text mb={2} color="gray.600">
                                  Date de mission: {new Date(missionGroup.mission.date_mission).toLocaleDateString("fr-FR")}
                                </Text>
                              )}
                              {missionGroup.mission && (
                                <Text mb={2} color="gray.600">
                                  Adresse: {missionGroup.mission.adresse}
                                </Text>
                              )}
                              <Text fontWeight="semibold" mt={3} mb={2} color="blue.500">
                                Matériels utilisés (par type)
                              </Text>
                              {mainKeys.map((k) => renderUsageCategoryBlock(k, groupedUsage[k]))}
                              {renderUsageCategoryBlock("autre", groupedUsage.autre)}
                            </Box>
                          );
                        })}
                      </Box>
                    ) : (
                      <Text color="gray.500">Aucun historique d&apos;utilisation disponible</Text>
                    )}
                  </Box>
                </SimpleGrid>
              );
            })()}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onInventoryClose}>
              Fermer
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >

      {/* Maintenance Modal - Style Moderne */}
      < Modal isOpen={isMaintenanceOpen} onClose={onMaintenanceClose} size="6xl" >
        <ModalOverlay bg="blackAlpha.600" />
        <ModalContent maxW="1400px" borderRadius="xl" boxShadow="2xl">
          <ModalHeader bg="gradient-to-r" bgGradient="linear(to-r, blue.500, purple.600)" color="white" borderRadius="xl 0 0 0">
            <HStack spacing={4} align="center">
              <Box p={2} bg="whiteAlpha.200" borderRadius="lg">
                <MdBuild size={24} />
              </Box>
              <VStack align="start" spacing={1}>
                <Text fontSize="2xl" fontWeight="bold">Gestion de la Maintenance</Text>
                <Text fontSize="sm" opacity={0.9}>
                  Véhicule: {maintenanceData?.immatriculation} • {maintenanceData?.type_vehicule}
                </Text>
              </VStack>
            </HStack>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody p={6}>
            {maintenanceData && (
              <VStack spacing={8} align="stretch">
                {/* Header avec informations du véhicule - Style moderne */}
                <Box
                  bg="gradient-to-r"
                  bgGradient="linear(to-r, gray.50, blue.50)"
                  p={6}
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.200"
                  boxShadow="sm"
                >
                  <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
                    <Box textAlign="center">
                      <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={2}>VÉHICULE</Text>
                      <Text fontSize="xl" fontWeight="bold" color="gray.800">{maintenanceData.immatriculation}</Text>
                    </Box>
                    <Box textAlign="center">
                      <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={2}>TYPE</Text>
                      <Text fontSize="lg" fontWeight="semibold" color="blue.600">{maintenanceData.type_vehicule?.toUpperCase()}</Text>
                    </Box>
                    <Box textAlign="center">
                      <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={2}>STATUT</Text>
                      <Badge
                        colorScheme={
                          maintenanceData.statut === "disponible" ? "green" :
                            maintenanceData.statut === "en mission" ? "yellow" :
                              maintenanceData.statut === "entretien" ? "red" : "gray"
                        }
                        fontSize="md"
                        px={4}
                        py={2}
                        borderRadius="full"
                        textTransform="uppercase"
                        fontWeight="bold"
                      >
                        {maintenanceData.statut}
                      </Badge>
                    </Box>
                  </SimpleGrid>
                </Box>

                {/* Liste des tâches avec style moderne */}
                <Box>
                  <HStack justify="space-between" mb={6}>
                    <VStack align="start" spacing={1}>
                      <Text fontSize="xl" fontWeight="bold" color="gray.800">
                        Tâches de Maintenance
                      </Text>
                      <Text fontSize="sm" color="gray.500">
                        Gérez les tâches de maintenance de ce véhicule
                      </Text>
                    </VStack>
                    <Button
                      colorScheme="green"
                      size="md"
                      onClick={onTaskModalOpen}
                      borderRadius="lg"
                      leftIcon={<Text fontSize="lg">+</Text>}
                      boxShadow="md"
                      _hover={{ transform: "translateY(-1px)", boxShadow: "lg" }}
                    >
                      Ajouter une tâche
                    </Button>
                  </HStack>

                  {maintenanceTasks.length > 0 ? (
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
                      {maintenanceTasks.map((task) => (
                        <Box
                          key={task.id}
                          p={6}
                          borderRadius="xl"
                          bg="white"
                          border="1px solid"
                          borderColor="gray.200"
                          boxShadow="md"
                          transition="all 0.2s"
                          _hover={{
                            transform: "translateY(-2px)",
                            boxShadow: "xl",
                            borderColor: "blue.300"
                          }}
                          position="relative"
                          overflow="hidden"
                        >
                          {/* Indicateur de statut en haut */}
                          <Box
                            position="absolute"
                            top={0}
                            left={0}
                            right={0}
                            h="4px"
                            bg={
                              task.status === "ok" ? "green.400" :
                                task.status === "soon" ? "yellow.400" :
                                  task.status === "urgent" ? "red.400" : "gray.400"
                            }
                          />

                          <VStack align="stretch" spacing={4} h="100%">
                            {/* Header avec nom de tâche et statut */}
                            <HStack justify="space-between" align="start">
                              <Text
                                fontWeight="bold"
                                fontSize="lg"
                                color="gray.800"
                                flex={1}
                                noOfLines={2}
                                lineHeight="1.3"
                              >
                                {task.name}
                              </Text>
                              <Badge
                                colorScheme={
                                  task.status === "ok" ? "green" :
                                    task.status === "soon" ? "yellow" :
                                      task.status === "urgent" ? "red" : "gray"
                                }
                                fontSize="sm"
                                px={3}
                                py={1}
                                borderRadius="full"
                                fontWeight="bold"
                                textTransform="uppercase"
                              >
                                {task.status === "ok" ? "✓ OK" :
                                  task.status === "soon" ? "⚠ BIENTÔT" :
                                    task.status === "urgent" ? "🚨 URGENT" : task.status}
                              </Badge>
                            </HStack>

                            {/* Détails de la tâche */}
                            <VStack align="start" spacing={3} flex={1}>
                              <Box w="100%">
                                <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={1}>
                                  📅 Échéance
                                </Text>
                                <Text fontSize="md" color="gray.700">
                                  {task.next_due_date ? new Date(task.next_due_date).toLocaleDateString("fr-FR") : 'Non définie'}
                                </Text>
                              </Box>

                              {task.last_performed_at && (
                                <Box w="100%">
                                  <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={1}>
                                    🔧 Dernière exécution
                                  </Text>
                                  <Text fontSize="md" color="gray.700">
                                    {new Date(task.last_performed_at).toLocaleDateString("fr-FR")}
                                  </Text>
                                </Box>
                              )}

                              {task.notes && (
                                <Box w="100%">
                                  <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={1}>
                                    📝 Notes
                                  </Text>
                                  <Text fontSize="sm" color="gray.600" noOfLines={3}>
                                    {task.notes}
                                  </Text>
                                </Box>
                              )}
                            </VStack>

                            {/* Boutons de changement de statut - Style moderne */}
                            <VStack spacing={3}>
                              <Text fontSize="sm" fontWeight="semibold" color="gray.500" textAlign="center">
                                Changer le statut
                              </Text>
                              <HStack spacing={2} justify="center">
                                {task.status !== "ok" && (
                                  <Button
                                    size="sm"
                                    colorScheme="green"
                                    onClick={() => handleStatusChange(task.id, "ok")}
                                    flex={1}
                                    borderRadius="lg"
                                    fontWeight="semibold"
                                    leftIcon={<Text>✓</Text>}
                                    _hover={{ transform: "scale(1.05)" }}
                                  >
                                    OK
                                  </Button>
                                )}
                                {task.status !== "soon" && (
                                  <Button
                                    size="sm"
                                    colorScheme="yellow"
                                    onClick={() => handleStatusChange(task.id, "soon")}
                                    flex={1}
                                    borderRadius="lg"
                                    fontWeight="semibold"
                                    leftIcon={<Text>⚠</Text>}
                                    _hover={{ transform: "scale(1.05)" }}
                                  >
                                    BIENTÔT
                                  </Button>
                                )}
                                {task.status !== "urgent" && (
                                  <Button
                                    size="sm"
                                    colorScheme="red"
                                    onClick={() => handleStatusChange(task.id, "urgent")}
                                    flex={1}
                                    borderRadius="lg"
                                    fontWeight="semibold"
                                    leftIcon={<Text>🚨</Text>}
                                    _hover={{ transform: "scale(1.05)" }}
                                  >
                                    URGENT
                                  </Button>
                                )}
                              </HStack>
                            </VStack>
                          </VStack>
                        </Box>
                      ))}
                    </SimpleGrid>
                  ) : (
                    <Box
                      p={12}
                      textAlign="center"
                      bg="gradient-to-r"
                      bgGradient="linear(to-r, gray.50, blue.50)"
                      borderRadius="xl"
                      border="2px dashed"
                      borderColor="gray.300"
                    >
                      <Text fontSize="6xl" mb={4}>🔧</Text>
                      <Text fontSize="lg" fontWeight="semibold" color="gray.600" mb={2}>
                        Aucune tâche de maintenance définie
                      </Text>
                      <Text fontSize="sm" color="gray.500">
                        Commencez par ajouter votre première tâche de maintenance
                      </Text>
                    </Box>
                  )}
                </Box>
              </VStack>
            )}
          </ModalBody>
          <ModalFooter bg="gray.50" borderRadius="0 0 xl xl">
            <Button
              colorScheme="blue"
              mr={3}
              onClick={onMaintenanceClose}
              borderRadius="lg"
              px={8}
            >
              Fermer
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >

      {/* Add Task Modal */}
      < Modal isOpen={isTaskModalOpen} onClose={onTaskModalClose} >
        <ModalOverlay />
        <ModalContent maxW="600px">
          <ModalHeader>Ajouter une Tâche de Maintenance</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              <FormControl>
                <FormLabel>Nom de la tâche</FormLabel>
                <Input
                  value={newTaskData.name}
                  onChange={(e) => updateTaskField("name", e.target.value)}
                  placeholder="Ex: Changement d'huile"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Statut</FormLabel>
                <Select
                  value={newTaskData.status}
                  onChange={(e) => updateTaskField("status", e.target.value)}
                >
                  <option value="ok">OK</option>
                  <option value="soon">Bientôt</option>
                  <option value="urgent">Urgent</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Prochaine échéance</FormLabel>
                <Input
                  type="date"
                  value={newTaskData.next_due_date}
                  onChange={(e) => updateTaskField("next_due_date", e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Dernière exécution</FormLabel>
                <Input
                  type="date"
                  value={newTaskData.last_performed_at}
                  onChange={(e) => updateTaskField("last_performed_at", e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Notes</FormLabel>
                <Input
                  value={newTaskData.notes}
                  onChange={(e) => updateTaskField("notes", e.target.value)}
                  placeholder="Notes supplémentaires..."
                />
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleAddTask}>
              Ajouter
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >

      {/* Complete Maintenance Modal */}
      < Modal isOpen={isHistoryModalOpen} onClose={onHistoryModalClose} >
        <ModalOverlay />
        <ModalContent maxW="600px">
          <ModalHeader>
            <HStack spacing={2}>
              <Text>Finaliser la Maintenance</Text>
              <Badge colorScheme="green" fontSize="sm">OK</Badge>
            </HStack>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedTask && (
              <VStack spacing={4}>
                <Box bg="green.50" p={4} borderRadius="md" w="100%">
                  <Text fontWeight="bold" color="green.700" mb={2}>
                    Tâche: {selectedTask.name}
                  </Text>
                  <Text fontSize="sm" color="green.600">
                    Cette tâche va être marquée comme terminée et ajoutée à l'historique.
                  </Text>
                </Box>

                <FormControl>
                  <FormLabel>Kilométrage actuel</FormLabel>
                  <Input
                    type="number"
                    value={statusChangeData.odometer_km}
                    onChange={(e) => updateStatusChangeField("odometer_km", e.target.value)}
                    placeholder="Ex: 150000"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Coût de la maintenance (MAD)</FormLabel>
                  <Input
                    type="number"
                    step="0.01"
                    value={statusChangeData.cost_mad}
                    onChange={(e) => updateStatusChangeField("cost_mad", e.target.value)}
                    placeholder="Ex: 250.50"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Prochaine échéance</FormLabel>
                  <Input
                    type="date"
                    value={statusChangeData.next_due_date_set}
                    onChange={(e) => updateStatusChangeField("next_due_date_set", e.target.value)}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Notes de la maintenance</FormLabel>
                  <Input
                    value={statusChangeData.notes}
                    onChange={(e) => updateStatusChangeField("notes", e.target.value)}
                    placeholder="Détails de la maintenance effectuée..."
                  />
                </FormControl>
              </VStack>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" onClick={handleCompleteMaintenance}>
              Finaliser la Maintenance
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >

      {/* Vehicle History Modal */}
      < Modal isOpen={isVehicleHistoryOpen} onClose={onVehicleHistoryClose} size="6xl" >
        <ModalOverlay bg="blackAlpha.600" />
        <ModalContent maxW="1400px" borderRadius="xl" boxShadow="2xl">
          <ModalHeader bg="gradient-to-r" bgGradient="linear(to-r, purple.500, pink.600)" color="white" borderRadius="xl 0 0 0">
            <HStack spacing={4} align="center">
              <Box p={2} bg="whiteAlpha.200" borderRadius="lg">
                <Text fontSize="2xl">📊</Text>
              </Box>
              <VStack align="start" spacing={1}>
                <Text fontSize="2xl" fontWeight="bold">Historique de Maintenance</Text>
                <Text fontSize="sm" opacity={0.9}>
                  Véhicule: {maintenanceData?.immatriculation} • {maintenanceData?.type_vehicule}
                </Text>
              </VStack>
            </HStack>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody p={6}>
            {vehicleHistory.length > 0 ? (
              <VStack spacing={4} align="stretch">
                {/* Statistiques rapides */}
                <Box
                  bg="gradient-to-r"
                  bgGradient="linear(to-r, purple.50, pink.50)"
                  p={6}
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="purple.200"
                >
                  <SimpleGrid columns={{ base: 1, md: 4 }} spacing={4}>
                    <Box textAlign="center">
                      <Text fontSize="2xl" fontWeight="bold" color="purple.600">
                        {vehicleHistory.length}
                      </Text>
                      <Text fontSize="sm" color="gray.600">Actions totales</Text>
                    </Box>
                    <Box textAlign="center">
                      <Text fontSize="2xl" fontWeight="bold" color="green.600">
                        {vehicleHistory.filter(h => h.action === 'maintenance_completed').length}
                      </Text>
                      <Text fontSize="sm" color="gray.600">Maintenances terminées</Text>
                    </Box>
                    <Box textAlign="center">
                      <Text fontSize="2xl" fontWeight="bold" color="blue.600">
                        {vehicleHistory.filter(h => h.cost_mad && h.cost_mad > 0).reduce((sum, h) => sum + parseFloat(h.cost_mad), 0).toFixed(0)}
                      </Text>
                      <Text fontSize="sm" color="gray.600">Coût total (MAD)</Text>
                    </Box>
                    <Box textAlign="center">
                      <Text fontSize="2xl" fontWeight="bold" color="orange.600">
                        {vehicleHistory.filter(h => h.odometer_km && h.odometer_km > 0).length}
                      </Text>
                      <Text fontSize="sm" color="gray.600">Avec kilométrage</Text>
                    </Box>
                  </SimpleGrid>
                </Box>

                {/* Liste de l'historique */}
                <Box>
                  <Text fontSize="xl" fontWeight="bold" color="gray.800" mb={4}>
                    Historique détaillé
                  </Text>
                  <VStack spacing={4} align="stretch">
                    {vehicleHistory.map((history, index) => (
                      <Box
                        key={index}
                        p={6}
                        borderRadius="xl"
                        bg="white"
                        border="1px solid"
                        borderColor="gray.200"
                        boxShadow="md"
                        transition="all 0.2s"
                        _hover={{
                          transform: "translateY(-1px)",
                          boxShadow: "lg",
                          borderColor: "purple.300"
                        }}
                      >
                        <HStack justify="space-between" align="start" mb={4}>
                          <VStack align="start" spacing={2}>
                            <HStack spacing={3}>
                              <Badge
                                colorScheme={
                                  history.action === 'maintenance_completed' ? 'green' :
                                    history.action === 'status_changed' ? 'blue' : 'gray'
                                }
                                fontSize="sm"
                                px={3}
                                py={1}
                                borderRadius="full"
                                fontWeight="bold"
                              >
                                {history.action === 'maintenance_completed' ? '🔧 Maintenance' :
                                  history.action === 'status_changed' ? '🔄 Changement' : history.action}
                              </Badge>
                              <Text fontSize="lg" fontWeight="bold" color="gray.800">
                                {history.task_name}
                              </Text>
                            </HStack>
                            <Text fontSize="sm" color="gray.500">
                              {new Date(history.performed_at).toLocaleString("fr-FR", {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </Text>
                          </VStack>
                          <VStack align="end" spacing={1}>
                            {history.from_status && history.to_status && (
                              <HStack spacing={2}>
                                <Badge colorScheme="gray" fontSize="xs">
                                  {history.from_status}
                                </Badge>
                                <Text fontSize="sm" color="gray.500">→</Text>
                                <Badge
                                  colorScheme={
                                    history.to_status === "ok" ? "green" :
                                      history.to_status === "soon" ? "yellow" :
                                        history.to_status === "urgent" ? "red" : "gray"
                                  }
                                  fontSize="xs"
                                >
                                  {history.to_status}
                                </Badge>
                              </HStack>
                            )}
                          </VStack>
                        </HStack>

                        {/* Détails de l'historique */}
                        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                          {history.odometer_km && (
                            <Box>
                              <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={1}>
                                🚗 Kilométrage
                              </Text>
                              <Text fontSize="md" color="gray.700">
                                {history.odometer_km.toLocaleString()} km
                              </Text>
                            </Box>
                          )}
                          {history.cost_mad && (
                            <Box>
                              <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={1}>
                                💰 Coût
                              </Text>
                              <Text fontSize="md" color="gray.700">
                                {parseFloat(history.cost_mad).toFixed(2)} MAD
                              </Text>
                            </Box>
                          )}
                          {history.next_due_date_set && (
                            <Box>
                              <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={1}>
                                📅 Prochaine échéance
                              </Text>
                              <Text fontSize="md" color="gray.700">
                                {new Date(history.next_due_date_set).toLocaleDateString("fr-FR")}
                              </Text>
                            </Box>
                          )}
                        </SimpleGrid>

                        {history.notes && (
                          <Box mt={4}>
                            <Text fontSize="sm" fontWeight="semibold" color="gray.500" mb={2}>
                              📝 Notes
                            </Text>
                            <Text fontSize="sm" color="gray.600" bg="gray.50" p={3} borderRadius="md">
                              {history.notes}
                            </Text>
                          </Box>
                        )}
                      </Box>
                    ))}
                  </VStack>
                </Box>
              </VStack>
            ) : (
              <Box
                p={12}
                textAlign="center"
                bg="gradient-to-r"
                bgGradient="linear(to-r, purple.50, pink.50)"
                borderRadius="xl"
                border="2px dashed"
                borderColor="purple.300"
              >
                <Text fontSize="6xl" mb={4}>📊</Text>
                <Text fontSize="lg" fontWeight="semibold" color="gray.600" mb={2}>
                  Aucun historique disponible
                </Text>
                <Text fontSize="sm" color="gray.500">
                  L'historique des maintenances apparaîtra ici une fois que des actions auront été effectuées
                </Text>
              </Box>
            )}
          </ModalBody>
          <ModalFooter bg="gray.50" borderRadius="0 0 xl xl">
            <Button
              colorScheme="purple"
              mr={3}
              onClick={onVehicleHistoryClose}
              borderRadius="lg"
              px={8}
            >
              Fermer
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >


    </Box >
  );
}
